import React, { Component } from 'react';
import { EditorState, convertFromRaw } from 'draft-js';
import cryptoRandomString from 'crypto-random-string';
import { Text } from '../../../../../../../../../ui-kit';
import AddReply from '../../AddReply';
import EditReply from '../../EditReply';
import Reply from './Reply';
import '../styles/_replies.scss';






















class Replies extends Component {


  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      updateEditorState: EditorState.createEmpty(),
      showEditReplyForm: false,
      commentIdToEdit: '',
      updateCommentOwner: {}
    };
  }

  replyToComment = ({ userId, name }) => {
    const contentData = {
      blocks: [
      {
        key: cryptoRandomString({ length: 5 }),
        text: `${name}`,
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [
        {
          offset: 0,
          length: name.length,
          key: 'one'
        }],

        data: {}
      }],

      entityMap: {
        one: {
          type: 'mention',
          mutability: 'SEGMENTED',
          data: {
            mention: {
              userId,
              name
            }
          }
        }
      }
    };

    const contentState = convertFromRaw(contentData);
    const editorState = EditorState.createWithContent(contentState);

    this.setState({ editorState });
  };

  toggleEditReply = (
  { commentId,
    content,
    createdByUser




  }) => {
    if (content && commentId) {
      const contentState = convertFromRaw(content);
      const editorState = EditorState.createWithContent(contentState);
      this.setState({
        updateEditorState: editorState,
        showEditReplyForm: true,
        commentIdToEdit: commentId,
        updateCommentOwner: createdByUser
      });
    }
  };

  handleEditUpdateContent = (editorState) => {
    this.setState({ updateEditorState: editorState });
  };

  handleUpdateContent = (editorState) => {
    this.setState({ editorState });
  };

  clearInput = () => this.setState({
    editorState: EditorState.createEmpty(),
    showEditReplyForm: false
  });

  setReplyRef = (replyRef) => {
    if (!replyRef) {return;}

    // eslint-disable-next-line no-param-reassign
    replyRef.scrollTop = replyRef.scrollHeight;

    this._replyRef = replyRef;
  };

  render() {
    const {
      createReply,
      editReply,
      deleteReply,
      comment,
      isReadOnly,
      resourceOrganisationId,
      isResourceOwner,
      onInputFocus,
      shotId,
      sceneId
    } = this.props;

    const replies = comment?.children ?? [];

    const {
      editorState,
      updateEditorState,
      showEditReplyForm,
      commentIdToEdit,
      updateCommentOwner
    } = this.state;

    if (!replies.length) {return null;}

    return (
      <div className="replies-section-container">
        <div className="replies-section-container__heading">
          <Text noMargin>{`Replies (${replies.length})`}</Text>
        </div>
        <div className="replies-section-container__replies-wrapper">
          <div className="replies-section-container__replies-wrapper__list" ref={this.setReplyRef}>
            {
            replies.map(({ commentId, createdByUser, content, assetIds }) =>
            <div className="replies-section-container__replies-wrapper__list-item" key={commentId}>
                  {showEditReplyForm && commentIdToEdit === commentId ?
              <EditReply
                commentId={commentIdToEdit}
                editReply={editReply}
                comment={comment}
                createdByUser={updateCommentOwner}
                onUpdateContent={this.handleEditUpdateContent}
                editorState={updateEditorState}
                clearInput={this.clearInput}
                replyRef={this._replyRef}
                visible={!isReadOnly}
                resourceOrganisationId={resourceOrganisationId}
                onInputFocus={onInputFocus} /> :


              <Reply
                key={commentId}
                deleteReply={deleteReply}
                editReply={this.toggleEditReply}
                replyToComment={this.replyToComment}
                commentId={commentId}
                assetIds={assetIds}
                createdByUser={createdByUser}
                content={content}
                parentComment={comment}
                isReadOnly={isReadOnly}
                isResourceOwner={isResourceOwner} />}


                </div>
            )}

          </div>
          <AddReply
            createReply={createReply}
            comment={comment}
            onUpdateContent={this.handleUpdateContent}
            editorState={editorState}
            clearInput={this.clearInput}
            replyRef={this._replyRef}
            visible={!isReadOnly}
            resourceOrganisationId={resourceOrganisationId}
            onInputFocus={onInputFocus}
            shotId={shotId}
            sceneId={sceneId} />

        </div>
      </div>);

  }
}

export default Replies;